import { BRANDSETTINGS } from "constants/action-types";
import siteConfig from "site-config";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";
import { baseActionEpic, IRequestAction } from "../base-epic";

export const updateImageFormats = baseActionEpic<IRequestAction>(
    BRANDSETTINGS.IMAGE_FORMATS.UPDATE.START,
    ({ payload }) => ({ method: "POST", url: siteConfig.api + "/brand/settings", body: payload }),
    ({ response, status }, action, store) => {
        if (response && status === 200) {
            return [
                {
                    payload: response,
                    type: BRANDSETTINGS.IMAGE_FORMATS.UPDATE.SUCCESS,
                },
                snackbarAdd({ message: "Image formats updated" }),
            ];
        } else {
            return [
                {
                    payload: [],
                    error: true,
                    type: BRANDSETTINGS.IMAGE_FORMATS.UPDATE.ERROR,
                },
                snackbarAdd({ message: "Error saving Image Formats" }),
            ];
        }
    },
);
